import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { inject, observer, PropTypes as MobXPropTypes } from 'mobx-react';
import { BackButton } from 'components/common/BackButton/BackButton';
import { ROUTE_PATHS } from 'routes/constants';

const NewPaymentFormV2 = ({ newPaymentStore }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const handleBackButtonClick = () => {
    if (newPaymentStore.getCurrentStepIndex() === 0) {
      navigate(ROUTE_PATHS.NEW_PAYMENT_V2);
      newPaymentStore.resetNewPaymentFormCreationData();
    } else {
      newPaymentStore.goToPrevStep();
    }
  };

  return (
    <section className={'page-container'}>
      <Outlet />
    </section>
  );
};

NewPaymentFormV2.propTypes = {
  newPaymentStore: MobXPropTypes.observableObject
};

export default inject((stores) => ({
  newPaymentStore: stores.newPaymentStore
}))(observer(NewPaymentFormV2));
